import ForgetasswordForm from './lib/form';

import * as S from './styles';
import { Link } from 'react-router-dom';

export default function ForgePasswordPage() {
  return (
    <S.AuthContainer>
      <S.FormLogin>
        <S.FormTitle>Forgot password</S.FormTitle>
        <S.SubTitle>Enter your email address and we will send you a link to reset your password.</S.SubTitle>
        <ForgetasswordForm />
        <S.Foot>
          <S.Div>
            Already have login and password? <Link to="/auth/login">Sign in</Link>
          </S.Div>
        </S.Foot>
      </S.FormLogin>
    </S.AuthContainer>
  );
}
